import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LoadingConstants from 'app/shared/constants/LoadingConstants';

const initState = () => ({
    downloadState: LoadingConstants.INITIAL,
    downloadErrorMessage: null,
});

const download = (state = initState(), action = {}) => {
    const { type } = action;

    switch (type) {
        case DispatchConstants.BILLING_SET_INVOICE_DOWNLOAD_STATE:
            return {
                ...state,
                downloadState: action.payload,
            };
        case DispatchConstants.BILLING_SET_INVOICE_DOWNLOAD_ERROR_MESSAGE:
            return {
                ...state,
                downloadErrorMessage: action.payload,
            };
        default:
            return state;
    }
};

export default download;
